import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitPartnerData = createSelector(
  selectFinancialCockpitState,
  ({ partnerData }) => partnerData
)
